/* eslint-disable jira/filename-case */
export const LICENSE_STATE_ACTIVE = 'ACTIVE' as const;
export const LICENSE_STATE_SUSPENDED = 'SUSPENDED' as const;
export const LICENSE_STATE_EXPIRED = 'EXPIRED' as const;
export const LICENSE_STATE_UNLICENSED = 'UNLICENSED' as const;

export type ApplicationLicenseState = 'ACTIVE' | 'SUSPENDED' | 'EXPIRED' | 'UNLICENSED';

export type ApplicationLicenseStates = {
	readonly core: ApplicationLicenseState;
	readonly software: ApplicationLicenseState;
	readonly serviceDesk: ApplicationLicenseState;
	readonly customerService: ApplicationLicenseState;
	readonly productDiscovery: ApplicationLicenseState;
};

export const populateApplicationLicenseStates = (
	overrides: Partial<ApplicationLicenseStates> = {},
	defaultLicenseState: ApplicationLicenseState = LICENSE_STATE_UNLICENSED,
): ApplicationLicenseStates => ({
	core: defaultLicenseState,
	software: defaultLicenseState,
	serviceDesk: defaultLicenseState,
	customerService: defaultLicenseState,
	productDiscovery: defaultLicenseState,
	...overrides,
});
